const FooterPage = () => {

    return (
        <footer className="theme-border theme-muted container mx-auto flex flex-row gap-4 border-t p-6">
            <div>
                <p className="text-center italic font-semi-bold">© 2025-2026 DoCode. All Rights Reserved.</p>
            </div>
        </footer>
    );
};

export default FooterPage;
